<template>   
	<div>  
        <div class="row mb-5" :class="pesquisar ? 'mt-2' : ''">
            <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-3" v-if="pesquisar"> 
                <label  for="search" class="form-label">Pesquisar:</label>  
                <input @keyup="apertouEnter" type="text" :data-kt-docs-table-filter="'search' + id" class="form-control form-control-solid" placeholder="Pesquisar"/>  
            </div> 
            <slot name="filtros" style="padding: 20px;"></slot>  
        </div>  
        <table  :id="id" class="table align-middle table-striped fs-6 border table-rounded table-hover mt-2" data-state-save="false">
            <thead>
                <tr class="text-start text-gray-400 fw-bolder fs-7 gs-0">
                    <slot></slot> 
                </tr>
            </thead> 
        </table> 
	</div>
</template>

<script lang="ts"> 
     
    require('datatables.net');
	require('datatables.net-bs4'); 
	require('datatables.net-responsive');
	require('datatables.net-responsive-bs4');
  
    import { Options, Vue   } from "vue-class-component";   
    import jQuery  from 'jquery';   
    import { Prop , Watch } from 'vue-property-decorator';
    import ApiService from "@/service/ApiService"; 
 
    @Options({
        name: "KDataTable",
        components: { },  
    }) 
    export default class KDataTable extends Vue {
 
        @Prop({required: true}) readonly config!: any 
        @Prop({required: false})  reload!: boolean
        @Prop({required: false , default:true })  pesquisar!: boolean 
        @Prop({required: false , default:'tableatualizada' })  evento!: any
 
        private datatable: any = null;
		public id: any = null;
     
        @Watch('reload')
		tabelaAtualizada(newVal: string) {
			this.datatable.ajax.reload(); 
		}
        
        public apertouEnter(e){ 
            if(e.key === 'Enter' || e.keyCode === 13){
                setTimeout(() => {
                    this.tabelaAtualizada('');
                }, 300); 
            }
        }

        created(){
			this.id = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15); 
		}
 
        mounted() {
			this.datatable = this.montarDatatable( );   
		}

        private montarParametrosAjaxPadrao(d: any) {
            const dados: Record<string, string | number | boolean | null> = {
                "Skip": d.start,
                "Take": d.length,
                "search": d.search ? d.search.value : null
            };

            if (d.order && d.order.length > 0) {
                d.order.forEach((orderConfig, index) => {
                    const columnConfig = d.columns ? d.columns[orderConfig.column] : null;
                    const direction = orderConfig ? orderConfig.dir : null;

                    dados["order" + index] = columnConfig ? columnConfig.name : null;
                    dados["asc" + index] = direction === "asc" ? true : direction === "desc" ? false : null;
                });
            }

            return dados;
        }

        private padronizarAjaxData(config: any) {
            const ajaxData = config.ajax ? config.ajax.data : null;
            const montarParametrosAjaxPadrao = (d) => this.montarParametrosAjaxPadrao(d);

            config.ajax.data = function (d, settings) {
                const dadosPadrao = montarParametrosAjaxPadrao(d);

                if (typeof ajaxData === "function") {
                    const dadosTela = ajaxData.call(this, d, settings);
                    return jQuery.extend(true, {}, dadosPadrao, dadosTela);
                }

                if (ajaxData && typeof ajaxData === "object") {
                    return jQuery.extend(true, {}, dadosPadrao, ajaxData);
                }

                return dadosPadrao;
            };
        }
 
		public montarDatatable(  ) {   
				const seletorTabela = '#' + this.id ;   
                const configPadrao = {
                    lengthMenu:  [ [ 5, 10, 15, 25, 40, 50, -1], [5, 10, 15, 25, 40, 50, "Todos"] ],
                    bStateSave: false,
                    dom:  "<'row'<'col-xs-12'<'col-xs-12'><'col-xs-12' >>r>" + "<'row'<'col-xs-12't>>" + "<'row'<'col-lg-3'l><'col-lg-6'p><'col-lg-3'i>>", // "<'row'<'col-lg-12'<'col-lg-12'><'col-lg-12' >>r>"+ "<'row'<'col-lg-12't>>"+ "<'row'<'col-lg-4'i><'col-lg-8'p>>",
                    searchDelay: 500,
                    processing: true,
                    serverSide: true, 
                    responsive: true,
                    stateSave: true,
                    select: {
                        style: 'multi',
                        selector: 'td:first-child input[type="checkbox"]',
                        className: 'row-selected'
                    },
                    fnStateSave: function (oSettings, oData) {
                        // localStorage.setItem( 'DataTables', JSON.stringify(oData) );
                    },
                    fnStateLoad: function (oSettings) {
                        return null;
                    }, 
                    ajax: {
                        type: 'get',	 
                        headers: ApiService.getHeader() ,
                        dataFilter: function(data){
                            var json = jQuery.parseJSON( data );
                            json.recordsTotal = json.total;
                            json.recordsFiltered = json.total; 
                            return JSON.stringify( json ); 
                        },
                        data: function ( d ) {  
                            const dados = {
                                "Skip": d.start,
                                "Take": d.length,
                                "search": d.search.value
                            }
                            return dados; 
                        }  
                    }, 
					language: { 
                        "sEmptyTable": "Nenhum registro encontrado",
                        "sInfo": "Mostrando de _START_ até _END_ de _TOTAL_ registros",
                        "sInfoEmpty": "Mostrando 0 até 0 de 0 registros",
                        "sInfoFiltered": "(Filtrados de _MAX_ registros)",
                        "sInfoPostFix": "",
                        "sInfoThousands": ".",
                        "sLengthMenu": "_MENU_ resultados por página",
                        "sLoadingRecords": "Carregando...",
                        "sProcessing": "Processando...",
                        "sZeroRecords": "Nenhum registro encontrado",
                        "sSearch": "Pesquisar",
                        "oPaginate": {
                            "sNext": "Próximo",
                            "sPrevious": "Anterior",
                            "sFirst": "Primeiro",
                            "sLast": "Último"
                        },
                        "oAria": {
                            "sSortAscending": ": Ordenar colunas de forma ascendente",
                            "sSortDescending": ": Ordenar colunas de forma descendente" 
                        }
					}, 
   
			    }; 
			     
				const config = jQuery.extend(true, {}, configPadrao , this.config );
                this.padronizarAjaxData(config);
				jQuery.fn.dataTable.ext.errMode = 'none'; 
				const dataTable = jQuery(seletorTabela).DataTable(config);  
				dataTable.on( 'draw',   () => {
					this.$emit( this.evento , this.datatable.ajax.params() );  
				});
 
                dataTable.on( 'click.tr', (e) => {
                    var data = null;
                    if(jQuery(e.target).is("td")) {
                        data = dataTable.row( e.target._DT_CellIndex.row ).data() ; 
                    }
                    else{
                        data = dataTable.row( jQuery(e.target).parents("td").first()[0]._DT_CellIndex.row ).data() ; 
                    } 
					this.$emit( 'clicou_linha' , data );  
				});
 
                const filterSearch = document.querySelector('[data-kt-docs-table-filter="search'+ this.id +'"]');
                if(filterSearch){
                    filterSearch!.addEventListener('keyup', function ( this , e  ) { 
                    if (e.type === 'change' || ( e as KeyboardEvent).key === 'Enter') {
                        dataTable.search(this.value).draw();
                    }
                }); 
            } 
            return dataTable;
		} 
    }
 
</script>
 
<style>  
    .btn-sm{
        margin-left: 10px; 
        margin-bottom: 5px; 
        padding: 0.55rem 1rem !important; 
    } 
    div.dataTables_wrapper div.dataTables_processing {
        position: absolute;
        top: 40%;
        left: 50%;
        width: 200px;
        margin-left: -100px;
        margin-top: -26px;
        text-align: center;
        padding: 1em 0;
    } 
    .table tr{
        border-width:0px;
    } 
    thead>tr>th{
        /* background-color: grey !important; */
        color: white !important;
        font-size: 15px !important;
    } 
    th, td{
        padding-left: 5px !important;
    } 
    @media screen and (max-width: 600px)  {
         thead>tr>th{ 
            background-color: #bcebfd !important;
            color: black !important;
            font-size: 12px !important;
        }
    } 
</style>

<style scoped>
    .card-header { 
        border-bottom: 1px solid #333436 !important;
    }

    .table {
        /* border: 1px solid #a2a3a5 !important; */
        /* border-spacing: 10px; */
    }

    .table > thead > tr { 
        background-color: #304988;  
        /* background-color: #c4c5c5;   */
        color: white !important;
    } 
 
</style>

<style> 
      
    .table > thead > tr > th:first-child {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 0px;
    }

    .table > thead > tr > th:last-child {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 0px;
    }

</style>
